import React, {useEffect, useRef, useState} from 'react';
import { Formik, Form, Field } from 'formik';
import TitleMain from "../Title/TitleMain";
import {resetPassword} from "../../services/AuthService";
import styles from "./LoginForm.module.css";
import FieldCustom from "../Field/FieldCustom";
import {useModal} from "../../contexts/ModalContext";
import BtnSave from "../Button/BtnSave";
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBackward, faExternalLink} from "@fortawesome/free-solid-svg-icons";
import Routing from "../../services/routing";
import ReCAPTCHA from "react-google-recaptcha";

function PasswordResetForm() {
    const { showModal, hideModal } = useModal();
    const [captchaLoaded, setCaptchaLoaded] = useState(false);
    const [captchaValue, setCaptchaValue] = useState('');
    const recaptchaRef = useRef(null);

    const onCaptchaChange = (value) => {
        setCaptchaValue(value);
    };

    const handleCaptchaLoaded = () => {
        setCaptchaLoaded(true);
    };

    const renderCaptcha = () => {
        const captchaKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
        if (!captchaKey) {
            console.error("Captcha key is missing");
            return null;
        }

        return (
            <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={captchaKey}
                size="invisible"
                onChange={onCaptchaChange}
                asyncScriptOnLoad={handleCaptchaLoaded}
            />
        );
    };

    const handleSuccess = (children = "Succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const onSubmit = async (values, { setSubmitting }) => {
        if (!captchaValue) {
            handleError('Veuillez vérifier que vous n\'êtes pas un robot');
            setSubmitting(false);
            return;
        }

        values.captchaToken = captchaValue;

        try {
            const response = await resetPassword(values);
            if (response.success) {
                handleSuccess(response.message);
                setTimeout(() => {
                    window.location.href = Routing.routes.login;
                }, 1500);
            } else {
                handleError(response.message);
            }
        } catch (error) {
            console.error('Erreur lors de la réinitialisation du mot de passe:', error);
            handleError('Erreur lors de la réinitialisation du mot de passe');
        }
        setSubmitting(false);
    }

    useEffect(() => {
        if (captchaLoaded && recaptchaRef.current) {
            recaptchaRef.current.execute();
        }
    }, [captchaLoaded]);

    return (
        <Formik
            initialValues={{ email: '', captchaToken: "" }} onSubmit={onSubmit}>
            {({ isSubmitting }) => (
                <Form className={styles.form}>
                    <div>
                        <TitleMain text="Mot de passe perdu ?" />

                        <FieldCustom label={"Email"} type={"email"} name={"email"} placeholder={"Entrez votre email"}/>

                        <p className={styles.info}>Saisissez votre E-mail puis cliquez sur envoyer. Vous recevrez un email de réinitialisation de mot de passe.</p>

                        {renderCaptcha()}
                    </div>

                    <button type="submit" className={`btn ${styles.btn}`} disabled={isSubmitting}>
                        Envoyer
                    </button>
                </Form>
            )}
        </Formik>
    );
}

export default PasswordResetForm;
